module.exports = __webpack_public_path__ + "img/create-team-done.903cbdc0.gif";